import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../components/Toast';

export default function Login() {
  const { login } = useAuth();
  const toast = useToast();
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');

  async function doLogin(e) {
    e.preventDefault();
    try {
      await login(user, pass);
    } catch (err) {
      toast(err.response?.data?.message || 'Sai tên đăng nhập hoặc mật khẩu', 'danger');
    }
  }

  return (
    <div id="login">
      <div className="login-blobs" aria-hidden="true">
        <span className="blob b1" />
        <span className="blob b2" />
        <span className="blob b3" />
        <span className="blob b4" />
      </div>
      <div className="login-card">
        <div className="brand">
          <img className="logo" src="/icon.svg" alt="FunnyTask" />
          <h1>FunnyTask</h1>
        </div>
        <div className="login-sub">Hệ thống quản lý công việc nội bộ</div>

        <form onSubmit={doLogin}>
          <label>Email / Số điện thoại</label>
          <input value={user} onChange={(e) => setUser(e.target.value)} placeholder="Email, SĐT hoặc tên đăng nhập" autoComplete="off" />
          <label>Mật khẩu</label>
          <input type="password" value={pass} onChange={(e) => setPass(e.target.value)} placeholder="••••••••" />
          <button className="btn full" type="submit">
            Đăng nhập
          </button>
        </form>
      </div>
    </div>
  );
}
